/**
 * Copyright (c) Microsoft. All rights reserved.
 */

import { action, observable } from 'mobx';

export class AuthStore {
    @observable public isLoading: boolean = true;

    @observable public isSignedIn: boolean = false;

    /**
     * Sets the is loading flag to the value given.
     *
     * @param value The value to set.
     */
    @action
    public setIsLoading(value: boolean) {
        this.isLoading = value;
    }

    /**
     * Sets the is signed in flag to the value given.
     *
     * @param value The value to set.
     */
    @action
    public setIsSignedIn(value: boolean) {
        this.isSignedIn = value;
    }
}
